import type { IconProps } from '../types/IconProps.ts';
export const ShoppingBagPlus: IconProps = {
    name: 'ShoppingBagPlus',
    children: [
        `<path d="M21 13V6l-2.7-3.6a1 1 0 0 0-.8-.4h-11a1 1 0 0 0-.8.4L3 6v15a1 1 0 0 0 1 1h9m8-16H3M19 17v4M17 19h4" />`,
        `<path d="M16 10a4 4 0 0 1-8 0" />`,
    ]
};